import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRepository } from '../Common/Data/base.repository';

@Injectable(
    {providedIn: 'root'}
)
export class UserGroupRepository extends BaseRepository {
    constructor(
        httpClient: HttpClient
    ) {
        super(httpClient);
    }

    private readonly SERVICE_URL = '/api/usergroup/';

    getAll(instanceId: number): Observable<any[]> {
        return this.httpGet(this.SERVICE_URL + 'instance/' + instanceId);
    }

    getById(id: number) {
        const url = this.SERVICE_URL + id;
        const config = {};

        return this.httpGet(url, config);
    }

    getForMember(userGuid: string) : Observable<Weissman.Model.Authentication.UserGroup[]> {
        const url = this.SERVICE_URL + 'member';
        const config = {
            params: {
                userid: userGuid
            }
        };

        return this.httpGet(url, config);
    }

    getForSetup(contactId: number): Observable<Weissman.Model.Authentication.UserGroup[]> {
        return this.httpGet(`${this.SERVICE_URL}setup/${contactId}`);
    }

    getList(pageNumber: number, pageSize: number, searchTerm?: number): Observable<any[]> {
        const config = {
            params: {
                pageNumber: pageNumber,
                pageSize: pageSize,
                searchText: null
            }
        };

        if (searchTerm) {
            config.params.searchText = searchTerm;
        }

        return this.httpGet(this.SERVICE_URL, config);
    }

    update(userGroup, batch): Observable<any> {
        const url = this.SERVICE_URL + userGroup.groupID;
        const config = {
            params: {
                batch: batch
            }
        };

        return this.httpPut(url, userGroup, config);
    }

    create(userGroup, batch): Observable<any> {
        const config = {
            params: {
                batch: batch
            }
        };

        return this.httpPost(this.SERVICE_URL, userGroup, config);
    }

    deleteById(id: number): Observable<any> {
        const url = this.SERVICE_URL + id;

        return this.httpDelete(url, {});
    }

    isUserSuperUser(): Observable<boolean> {
        return this.httpGet('/api/Account/IsSuperUser');
    }
}
